"use client"

import { AlertCircle, Sun, Focus, Scan } from "lucide-react"
import { Button } from "@web/components/ui/button"
import { useLanguage } from "@web/lib/contexts/language-context"

interface SeloModalProps {
  onRetry?: () => void
}

export function SealModal({ onRetry }: SeloModalProps) {
  const { t } = useLanguage();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="rounded-3xl w-[90vw] p-6 bg-white">
        <div className="flex flex-row items-center justify-center gap-2 mb-4">
          <AlertCircle className="h-6 w-6 text-red-500" />
          <h2 className="text-xl font-semibold text-zinc-900">
            {t.qrCodePage.sealModal.title}
          </h2>
        </div>

        <div className="space-y-5 mt-2">
          <div className="flex items-start gap-4">
            <div className="shrink-0">
              <Sun className="h-6 w-6 text-red-500" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-semibold text-zinc-900">{t.qrCodePage.sealModal.lightingTitle}</h3>
              <p className="text-sm text-zinc-500">{t.qrCodePage.sealModal.lightingDesc}</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="shrink-0">
              <Scan className="h-6 w-6 text-red-500" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-semibold text-zinc-900">{t.qrCodePage.sealModal.framingTitle}</h3>
              <p className="text-sm text-zinc-500">{t.qrCodePage.sealModal.framingDesc}</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="shrink-0">
              <Focus className="h-6 w-6 text-red-500" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-semibold text-zinc-900">{t.qrCodePage.sealModal.focusTitle}</h3>
              <p className="text-sm text-zinc-500">{t.qrCodePage.sealModal.focusDesc}</p>
            </div>
          </div>
        </div>

        <Button
          onClick={onRetry}
          className="w-full mt-4 bg-red-500 hover:bg-red-600 text-white rounded-full py-6 text-base font-medium"
        >
          {t.qrCodePage.sealModal.button}
        </Button>
      </div>
    </div>
  )
}